import { Component, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { EventResource } from 'src/app/interfaces/event-resource';
import { RaffleResponse } from 'src/app/interfaces/raffle';
import { EventService } from 'src/app/services/event.service';
import { RaffleService } from 'src/app/services/raffle.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-raffle',
  templateUrl: './raffle.component.html',
  styleUrls: ['./raffle.component.scss']
})
export class RaffleComponent implements OnInit {
  /**
   * The data to be displayed
   */
  dataSource: MatTableDataSource<any>;
  /**
   * The Columns of the Table
   */
  displayedColumns = ['number', 'customerNumber', 'attendingAccount.displayName', 'mail', 'created', 'state', 'voucherKey', 'paymentState', 'event.title']; 
  /**
   * The Form to let the user put in a winnercount
   */
  filterForm: UntypedFormGroup;
  /**
   * Has the user put in a winnercount 
   */
  hasSelectedWinnerCount: boolean = false;
  /**
   * The ID of the Event
   */
  eventID: string = "";
  /**
   * The CSV to be downloaded
   */
  currentWinnersCSV: string = "";
  /**
   * The current Event
   */
  currentEvent: EventResource;
  /***
   * constructor
   * Init the Form
   */
  constructor(
    private raffleService: RaffleService,
    private route: ActivatedRoute,
    private eventService: EventService,
    private fb: FormBuilder) {
    this.filterForm = this.fb.group({
      winnerCount: ['', [Validators.required]]
    })
  }

  /**
   * Get the Event via the URL
   */
  ngOnInit() {
    this.route.params.subscribe(params => {
      this.eventID = params['id']
    })

    this.eventService.getEvent(this.eventID).subscribe(event => {
      this.currentEvent = event;
    })
  }
/**
 * Get a List of Winners from the backend
 */
  getWinners() {
    this.raffleService.getWinnersForRaffle(this.eventID, this.filterForm.getRawValue().winnerCount).subscribe({
      next: (res: RaffleResponse) => {
        console.log(res)
        this.hasSelectedWinnerCount = true;
        this.dataSource = new MatTableDataSource(res.raffleEntries);
        this.currentWinnersCSV = "Kundennummer,Vorname,Nachname,Email,Reservierungsdatum,Status,Gutscheincode,Zahlungsstatus \n" + res.csv;
      },
      error: err => {
        console.log(err)
      }
    })
  }
/**
 * Create a CSV and download the File
 */
  exportCSV() {
    let id = uuidv4();
    //Split into lines
    let array = this.currentWinnersCSV.split('\n');
    let array2 = [];
    //convert string to array of strings after the comma
    array.forEach(element => {
      array2.push(element.split(','))
    });

    let csvContent = "data:text/csv;charset=utf-8,"
      + array2.map(e => e.join(",")).join("\n");

    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${encodeURIComponent(this.currentEvent.title)}_${id}.csv`);
    document.body.appendChild(link); // Required for FF

    link.click();
  }
}
